import { CodeBase } from "./_codeBase";

/** 連絡書受領区分*/
export class ReceiveContactFormDiv extends CodeBase<ReceiveContactFormDiv>
{

    /** 連絡書受領区分: "01", "（空白）"*/
    public static readonly NONE: ReceiveContactFormDiv = new ReceiveContactFormDiv("01", "　", "");
    /** 連絡書受領区分: "02", "受領"*/
    public static readonly RECEIPT: ReceiveContactFormDiv = new ReceiveContactFormDiv("02", "受領", "");

    /**
    * 
    * @param value
    * @param text
    */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ReceiveContactFormDiv[] {
        return [
            ReceiveContactFormDiv.NONE,
            ReceiveContactFormDiv.RECEIPT,

        ];
    }

}
